<template>
  <div id="app" v-loading.fullscreen.lock="fullscreenLoading">
    <router-view v-if="isRouterAlive" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import Home from './components/layout/Home.vue'
export default {
  data () {
    return {
      isRouterAlive: true,
      fullscreenLoading: this.$store.state.fullscreenLoading,
    }
    
  },
  provide () {
    return {
      reload: this.reload,
    }
  },
  name: 'app',
  components: {
     Home
  },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(()=>{
        this.isRouterAlive = true
      })

    }
  }
</script>

<style>
#app{
  width:100%;
  height:100%;
}
</style>
